import React from 'react';
import { Modal } from '@/components/ui/Modal';
import { ModalHeader } from '@/components/ui/ModalHeader';
import { ModalBody } from '@/components/ui/ModalBody';
import { ModalFooter } from '@/components/ui/ModalFooter';

interface LogoutConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  loading,
}) => (
  <Modal isOpen={isOpen} onClose={onClose} size="md" isLoading={loading}>
    <ModalHeader title="Confirm Logout" onClose={onClose} />
    <ModalBody>
      <div className="py-4 text-slate-600 text-sm leading-relaxed">
        Are you sure you want to log out? You will need to enter your credentials again to access the dashboard.
      </div>
    </ModalBody>
    <ModalFooter
      onCancel={onClose}
      onPrimary={onConfirm}
      cancelLabel="Cancel"
      primaryLabel="Log Out"
      primaryDisabled={loading}
      loading={loading}
      loadingLabel="Logging out..."
    />
  </Modal>
);
